import React, { useState } from 'react';
import PropTypes from 'prop-types';

import VisualMediaEmbeds from 'components/property/visual_media_embeds';
import PhotoBulkActions from 'components/photos/bulk_actions';
import { deleteVisualMedia, visualMediaId } from 'components/property/visual_media_shared';

export default function VisualMediaForm({
  embeds,
  parentName,
  visualMediaTypeOptions,
  onEmbedsChange
}) {
  const [selectedVisualMediaIds, setSelectedVisualMediaIds] = useState([]);

  const embedIds = embeds.map(visualMediaId);
  const noEmbeds = embeds.length === 0;
  const allSelected = noEmbeds ? false : embedIds.every(embedId => selectedVisualMediaIds.includes(embedId));
  const selectedEmbeds = embeds.filter(embed => selectedVisualMediaIds.includes(visualMediaId(embed)));

  function handleBulkCheckboxClick(id) {
    if (selectedVisualMediaIds.includes(id)) {
      setSelectedVisualMediaIds(selectedVisualMediaIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedVisualMediaIds([...selectedVisualMediaIds, id]);
    }
  }

  function handleSelectALl() {
    if (allSelected) {
      setSelectedVisualMediaIds([]);
    } else {
      setSelectedVisualMediaIds(embedIds);
    }
  }

  function handleBulkDelete() {
    const updatedEmbeds = deleteVisualMedia(embeds, selectedVisualMediaIds);

    onEmbedsChange(updatedEmbeds);
    setSelectedVisualMediaIds([]);
  }

  function handleBulkPreview() {
    selectedEmbeds.forEach((embed) => {
      if (embed.embedUrl) window.open(embed.embedUrl, '_blank');
    });
    setSelectedVisualMediaIds([]);
  }

  return (
    <div className="visual-media-container">
      <PhotoBulkActions
        allSelected={allSelected}
        disabled={selectedVisualMediaIds.length === 0}
        label="Visual Media"
        showLimit={false}
        onBulkDelete={handleBulkDelete}
        onBulkPreview={handleBulkPreview}
        onSelectAll={handleSelectALl}
      />
      <VisualMediaEmbeds
        mediaTypeOptions={visualMediaTypeOptions}
        parentName={parentName}
        selectedVisualMediaIds={selectedVisualMediaIds}
        visualMediaEmbeds={embeds}
        onBulkCheckboxClick={handleBulkCheckboxClick}
        onChange={onEmbedsChange}
      />
    </div>
  );
}

VisualMediaForm.propTypes = {
  embeds: PropTypes.array.isRequired,
  parentName: PropTypes.string.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onEmbedsChange: PropTypes.func.isRequired
};
